/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_OpenInputs */

const en_cmd_open = /** @type {(inputs: Cmd_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open item`)
};

const de_cmd_open = /** @type {(inputs: Cmd_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorgang öffnen`)
};

/**
* | output |
* | --- |
* | "Open item" |
*
* @param {Cmd_OpenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_open = /** @type {((inputs?: Cmd_OpenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_OpenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_open(inputs)
	return en_cmd_open(inputs)
});